import React from 'react'
import useCustomerAccountFeatureFlag from 'hooks/useCustomerAccountFeatureFlag'
import useFreeGapActivationJourney from 'hooks/useFreeGapActivationJourney'
import config from 'config'
import {
  GapActivationConfirmationContatiner,
  GapHeader,
  GapText,
  GapTitle,
  MotorEasyLogo,
} from './styles'
import Button from 'components/@common/Button'

interface Props {
  encyrptedQuoteId: string
}

const GapActivationConfirmation: React.FC<Props> = ({ encyrptedQuoteId }) => {
  const { data: featureFlagEnabled, isLoading: featureFlagLoading } =
    useCustomerAccountFeatureFlag('FreeGAPActivationJourney')

  const { data: useFreeGapActivation, isLoading: freeGapActivationLoading } =
    useFreeGapActivationJourney(encyrptedQuoteId)

  const gapActivationJourneyActive =
    !featureFlagLoading &&
    featureFlagEnabled &&
    featureFlagEnabled.data &&
    !freeGapActivationLoading &&
    useFreeGapActivation &&
    useFreeGapActivation.data &&
    useFreeGapActivation.data.FreeGapActivationJourneyValid

  const activateGapInsurance = () => {
    if (config.GAP_ACTIVATION_LINK !== '') {
      window.open(config.GAP_ACTIVATION_LINK, '_blank')?.focus()
    }
  }

  return (
    <>
      {gapActivationJourneyActive && (
        <GapActivationConfirmationContatiner>
          <GapHeader>
            <GapTitle>Don't forget to activate your GAP policy</GapTitle>
            <MotorEasyLogo />
          </GapHeader>
          <GapText id='GapActivationWording'>
            Your 30-day free GAP policy won't come into effect until you visit
            our partner MotorEasy. Click below to activate your free GAP policy
            in a few simple steps.
          </GapText>
          <Button
            marginBottom='32px'
            id='ActivateGapInsurance'
            fullWidth
            type='button'
            onClick={activateGapInsurance}
          >
            Activate Gap Insurance
          </Button>
        </GapActivationConfirmationContatiner>
      )}
    </>
  )
}

export default GapActivationConfirmation
